import { useState } from 'react';
import { Truck } from 'lucide-react';
import { useWaapDeliveryCharts, DELIVERY_TIME_RANGES, type DeliveryTimeRange } from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → Delivery Overview — NATIVE charts (Superset dashboard 106) rendered
 * through the shared board shell.
 */
export function DeliveryOverviewTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<DeliveryTimeRange>('Last 4 hours');
  const [domains, setDomains] = useState<string[]>([]);
  const query = useWaapDeliveryCharts(selected?.domainId, range, domains);
  return (
    <WaapAnalyticsBoard
      icon={<Truck size={26} />}
      label="delivery"
      ranges={DELIVERY_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      domains={domains}
      onDomainsChange={setDomains}
      query={query}
    />
  );
}
